
<template>
  <!--室内机管理-->
  <div>
    <x-tabula
      ref="table"
      rowKey="indoorEqId"
      :dataSource="dataSource"
      :searchList="searchList"
      :columns="columns"
      :tableOptList="tableOptList"
      :rowOptList="rowOptList"
      :searchParams.sync="searchParams"
      :listApi="listApi"
      :addHandleParam="addHandleParam"
      :deleteParam="deleteParam"
      :rowSelection="false"
      @resetSearch = "resetSearch"
    >
      <template slot="opt_status" slot-scope="{row}">
        <span>{{row.status === '1' ? '已绑定' : '未绑定'}}</span>
      </template>
      <template slot="opt_snCode" slot-scope="{row}">
        <span>HM-{{row.deviceSnCode.slice(-8)}}</span>
      </template>
    </x-tabula>
  </div>
</template>

<script>
import store from '@/store';
import { fetchSelect } from '@/utils/mixins';
export default {
  name: 'indoor',
  mixins: [fetchSelect],
  data () {
    return {
      searchList: [
        { props: ['deviceSnCode'], placeholder: '设备编码', options: [], inputType: 'input' },
        { props: [`${this.$route.name}/communityId`], placeholder: '小区', options: [], inputType: 'select', handle: $event => this.communityChange(2, $event), fetchOptions: this.getOptions },
        { props: [`${this.$route.name}/buildingId`], placeholder: '楼栋', options: [], inputType: 'select', handle: $event => this.buildingChange(3, $event) },
        { props: [`${this.$route.name}/unitId`], placeholder: '单元', options: [], inputType: 'select', handle: $event => this.unitChange(4, $event) },
        { props: [`${this.$route.name}/roomId`], placeholder: '房间', options: [], inputType: 'select' },
        { props: ['status'], placeholder: '状态', options: store.state.isBandList, inputType: 'select' }
      ],
      tableOptList: [],
      rowOptList: [
        {text: '解绑', handle: row => this.unbind(row), rowOptDisHandle: row => row.status === '0', permi: ['community:indoor:unbind']}
      ],

      columns: [
        { title: '设备编码', dataIndex: 'deviceSnCode', align: '', width: '', scopedSlots: {customRender: 'snCode'} },
        { title: '小区名称', dataIndex: 'communityName', align: '', width: '' },
        { title: '房间', dataIndex: 'roomAddress', align: '', width: '' },
        { title: '状态', dataIndex: 'status', align: '', width: '', scopedSlots: {customRender: 'status'} },
        { title: '操作', dataIndex: 'action', align: '', width: '', scopedSlots: {customRender: 'action'} }
      ],
      dataSource: [],
      searchParams: {
        deviceSnCode: undefined,
        [`${this.$route.name}/communityId`]: undefined,
        [`${this.$route.name}/buildingId`]: undefined,
        [`${this.$route.name}/unitId`]: undefined,
        [`${this.$route.name}/roomId`]: undefined,
        status: undefined
      },
      listApi: {
        url: '/indoor/list',
        resHandle: '', // this.resHandle
        searchHandle: '' // searchHandle
      },
      addHandleParam: {
        route: '',
        addTitle: '',
        EditTitle: ''
      },
      deleteParam: {
        url: '',
        paramKey: 'ids',
        valueKey: 'id',
        tipText: '',
        tipKey: ''
      }
    };
  },
  created () {
    // this.communitySelect(1, 'searchList', 1);
    this.communitySelectByStep(1, undefined, 'searchList', 1);
  },
  methods: {
    resetSearch () {
      this.communitySelectByStep(undefined, undefined, 'searchList', '1');
      this.searchList[1].searchValue = undefined;
    },
    getOptions (pageNum, search) {
      return this.communitySelectByStep(pageNum, search, 'searchList', 1);
    },
    /** 室内机 解绑 */
    unbind (row) {
      this.$confirm({
        title: `你确定要解绑 ${row.roomAddress}`,
        centered: true,
        onOk: () => {
          this.$post({
            url: '/indoor/unbind',
            params: { indoorEqId: row.indoorEqId }
          }).then(({ data }) => {
            this.$refs.table.getTableList();
          });
        }
      });
    },
    resHandle (res) {
      return res;
    },
    searchHandle (selectData) {
      return selectData;
    }
  }
};
</script>
